import { CheckCircle2, CircleDot, Circle, Undo2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtTime } from "@/lib/format";

export const sourceLabel = (p) => (!p ? "No position yet" : p.source === "gps" ? "Live GPS" : p.source === "gps_stale" ? "GPS signal lost" : "Demo simulation");

const isDone = (s) => ["arrived", "departed", "passed"].includes(s.status);

function StopTime({ s, i }) {
  if (i === 0) return <span>{s.status === "departed" ? `Departed ${fmtTime(s.actual)}` : `Departs ${fmtTime(s.scheduled)}`}</span>;
  if (s.status === "arrived") return <span className="font-bold text-emerald-700">Arrived {fmtTime(s.actual)}</span>;
  if (s.status === "passed") return <span>Passed</span>;
  return <span>{s.delay_min > 0 ? <>Expected <b className="text-rose-600">{fmtTime(s.eta)}</b> <span className="text-slate-400 line-through">{fmtTime(s.scheduled)}</span></> : <>Expected <b>{fmtTime(s.eta)}</b></>}</span>;
}

export default function StopTimeline({ timeline, fromIdx, toIdx, canMark, onMark }) {
  return (
    <ol className="relative space-y-0" data-testid="stop-timeline">
      {timeline.map((s, i) => {
        const mine = fromIdx != null && i >= fromIdx && i <= toIdx;
        const Icon = isDone(s) ? CheckCircle2 : timeline[i - 1] && isDone(timeline[i - 1]) ? CircleDot : Circle;
        return (
          <li key={s.station_id} className="relative flex gap-3 pb-4 last:pb-0" data-testid={`timeline-stop-${s.code}`}>
            {i < timeline.length - 1 && <span className={`absolute left-[11px] top-6 h-[calc(100%-1rem)] w-0.5 ${isDone(timeline[i + 1]) ? "bg-emerald-400" : "bg-slate-200"}`} />}
            <Icon className={`relative z-10 h-6 w-6 shrink-0 bg-white ${isDone(s) ? "text-emerald-500" : "text-slate-300"}`} />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-1.5">
                <b className="text-slate-900">{s.city}</b>
                {i === fromIdx && <span className="chip bg-blue-600 text-white">Board here</span>}
                {i === toIdx && <span className="chip bg-[#182678] text-white">Get off here</span>}
                {!mine && fromIdx != null && <span className="text-[10px] text-slate-400">not on your ticket</span>}
              </div>
              <div className="text-xs text-slate-500" data-testid={`timeline-time-${s.code}`}><StopTime s={s} i={i} /> {s.status === "arrived" && s.by ? <span className="text-slate-400">· by {s.by}</span> : null}</div>
            </div>
            {canMark?.(s, i) && (
              s.status === "arrived"
                ? <Button size="sm" variant="ghost" className="h-8 rounded-full text-xs" onClick={() => onMark(s, true)} data-testid={`undo-arrived-${s.code}`}><Undo2 className="h-3.5 w-3.5" />Undo</Button>
                : <Button size="sm" className="h-8 rounded-full bg-emerald-600 text-xs hover:bg-emerald-700" onClick={() => onMark(s, false)} data-testid={`mark-arrived-${s.code}`}>Mark arrived</Button>
            )}
          </li>
        );
      })}
    </ol>
  );
}
